module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/358.90d44cc0.png";